import React from "react";
import { IconButton as MUIIconButton, IconButtonProps } from "@mui/material";

const IconButton: React.FC<IconButtonProps> = (props) => {
    return <MUIIconButton {...props} />;
};

export default IconButton;
